exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".factoring-missing-info {\n  height: 100%;\n}\n\n.factoring-missing-info .navigation-content {\n  height: inherit;\n}\n\n.factoring-missing-info .navigation-content-wrap {\n  display: block;\n  height: auto;\n}\n\n.factoring-collaboration {\n  background-color: #7D16B4;\n  align-self: flex-end;\n  border-top-left-radius: 0.5rem;\n  border-bottom-left-radius: 0.5rem;\n}\n\n", ""]);

// exports
